import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineStore } from 'pinia';
import { applyDiscount } from '~/utils/pricing';
export var useOrdersStoreDefinition = defineStore('orders', {
  state: function state() {
    return {
      orders: {}
    };
  },
  getters: {
    getPaymentType: function getPaymentType(state) {
      return function (id) {
        var _state$orders$id;
        return (_state$orders$id = state.orders[id]) === null || _state$orders$id === void 0 ? void 0 : _state$orders$id.paymentType;
      };
    },
    getOrderByEventId: function getOrderByEventId(state) {
      return function (id) {
        return state.orders[id];
      };
    },
    getOrderPaymentData: function getOrderPaymentData(state) {
      return function (id) {
        var _state$orders$id2;
        return (_state$orders$id2 = state.orders[id]) === null || _state$orders$id2 === void 0 ? void 0 : _state$orders$id2.paymentData;
      };
    },
    /**
     * Return the order by ID and it's reduced tickets.
     *
     * Use the getOrderByEventId() getter to get the specific order and then
     * reduce the tickets to get the final price (faceValue - discount), and
     * add ticket holder to each ticket if needed.
     *
     * @returns Order and reduced tickets
     */
    getReducedOrder: function getReducedOrder() {
      var _this = this;
      return function (id) {
        var order = _this.getOrderByEventId(id);
        // If there are no orders
        if (!order) return null;
        if (order.market === 'primary') {
          var _order$orderData, _order$orderData$orde;
          var tickets = (_order$orderData = order.orderData) === null || _order$orderData === void 0 ? void 0 : (_order$orderData$orde = _order$orderData.orderItem) === null || _order$orderData$orde === void 0 ? void 0 : _order$orderData$orde.flatMap(function (orderItem) {
            return orderItem.ticket;
          }).map(function (ticket) {
            var _ticket$ticketHolder;
            return _objectSpread(_objectSpread({}, ticket), {}, {
              ticketHolder: (_ticket$ticketHolder = ticket.ticketHolder) !== null && _ticket$ticketHolder !== void 0 ? _ticket$ticketHolder : {},
              finalPrice: applyDiscount(ticket.ticketDiscount[0], ticket.ticketConfig.faceValue)
            });
          });
          return _objectSpread(_objectSpread({}, order), {}, {
            tickets: tickets
          });
        } else {
          var _tickets = order.orderData.order.offers.map(function (offer) {
            return _objectSpread(_objectSpread({}, offer), {}, {
              finalPrice: offer.price
            });
          });
          return _objectSpread(_objectSpread({}, order), {}, {
            tickets: _tickets
          });
        }
      };
    }
  },
  actions: {
    addOrder: function addOrder(payload) {
      this.orders = _objectSpread(_objectSpread({}, this.orders), {}, _defineProperty({}, payload.eventId, {
        orderId: payload.orderId,
        orderData: payload.orderData,
        orderTimeout: payload.orderTimeout,
        market: payload.market
      }));
    },
    deleteOrder: function deleteOrder(payload) {
      delete this.orders[payload.eventId];
    },
    clearOrders: function clearOrders() {
      this.orders = {};
    },
    addHolder: function addHolder(payload) {
      this.orders[payload.eventId].orderData.orderItem.forEach(function (oi) {
        var ticket = oi.ticket.find(function (t) {
          return t.id === payload.ticketId;
        });
        if (ticket) {
          ticket.ticketHolder = payload.ticketHolder;
        }
      });
    },
    addOrderContact: function addOrderContact(payload) {
      this.orders[payload.eventId].orderContact = payload.orderContact;
    },
    updateOrderData: function updateOrderData(payload) {
      var ticketHolders = [];
      this.orders[payload.eventId].orderData.orderItem.forEach(function (oi) {
        oi.ticket.forEach(function (ticket) {
          ticketHolders.push(ticket.ticketHolder);
        });
      });
      this.orders[payload.eventId].orderData = payload.orderData;
      this.orders[payload.eventId].orderData.orderItem.forEach(function (oi) {
        oi.ticket.forEach(function (ticket) {
          if (ticket.ticketHolder) {
            var ticketHolder = ticketHolders.find(function (th) {
              return (th === null || th === void 0 ? void 0 : th.id) === ticket.ticketHolder.id;
            });
            ticket.ticketHolder = _objectSpread(_objectSpread({}, ticket.ticketHolder), ticketHolder);
          }
        });
      });
    },
    updateOrderStatus: function updateOrderStatus(payload) {
      this.orders[payload.eventId].orderData.status = payload.status;
    },
    addPaymentType: function addPaymentType(payload) {
      this.orders[payload.eventId].paymentType = payload.paymentType;
    },
    addPaymentData: function addPaymentData(payload) {
      this.orders[payload.eventId].paymentData = payload.paymentData;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useOrdersStoreDefinition directly as
// useOrdersStore instead.
export function useOrdersStore() {
  return useOrdersStoreDefinition(usePinia());
}